import { __ } from '../../translations';
import url from '../../helpers/url';
import user from '../../helpers/user';
import { KIDSMODE } from '../../config/constants';
import { Text, Button } from '@intigral/shared';

export const ParentalLock = ({ onCTAHandler }: { onCTAHandler?: () => void }) => {
    return (
        <>
            <Text as="h2" variant="h2" margin={{ default: '2x', md: '3x' }}>
                {__('livetv_content_not_allowed_title')}
            </Text>
            <Text as="p" alignment="center" color="gray" margin={{ default: '2x', md: '4x' }}>
                {__('livetv_content_not_allowed_desc')}
            </Text>

            {user.getProfileMode() !== KIDSMODE.KID && (
                <Button
                    primary
                    style={{ width: '100%' }}
                    LinkComponent={'a'}
                    href={url.route('profile-settings')}
                    onClick={(_e) => {
                        onCTAHandler && onCTAHandler();
                    }}
                >
                    {__('parental_control_popup_btn_text')}
                </Button>
            )}
        </>
    );
};
